<template>
  <div class="container" id="permalinkPage">
    <div id="permalinkPageHome">
      <div class="nav">
        <div v-if="clinic && clinic.logo && clinic.logo.url" class="col-12 text-center booking-logo">
          <img :src="clinic.logo.url" :alt="clinic.clinic_name" :title="clinic.clinic_name"/>
        </div>
        <div v-else class="col-12 text-center py-4"/>
        <div class="row pb-menu-permalink">
          <div class="tab-content">
            <transition name="fade" mode="out-in" v-on:before-enter="beforeEnter" duration="200">
              <div :key="currentComponent">
                <div v-if="currentComponent === 'HomePermalinkDefault'" class="tab-pane active in">
                  <div id="homePermalink">
                    <HomePermalinkDefault @showChooseCategory="switchToChooseCategory"/>
                  </div>
                </div>
                <div v-if="currentComponent === 'Calendar'" class="pt-5 m-auto">
                  <div id="calendar" class="tab-pane active in">
                    <Calendar
                        @eventSelected="handleEventSelected"
                        @showCustomerInfo="switchToCustomerInfo"
                    />
                  </div>
                </div>
                <div v-if="currentComponent === 'ChooseTherapist'" class="pt-5 m-auto">
                  <div id="chooseTherapist" class="tab-pane active in">
                    <ChooseTherapist
                        :timepriceTherapists="selectTimepriceTherapists"
                        :selectedTimeprice="selectedTimeprice"
                        :currentCustomer="currentCustomer"
                        @showCalendar="switchToCalendar"
                        @goBack="goBackFromChooseTherapist"
                        @showCustomerInfo="switchToCustomerInfo"
                        @eventSelected="handleEventSelected"
                    />
                  </div>
                </div>
                <div v-if="currentComponent === 'ChooseCategory'" class="pt-5 m-auto">
                  <div id="chooseCategory" class="tab-pane active in">
                    <ChooseCategory
                        :categoryTimeprices="categoryTimeprices"
                        :otherTimeprices="otherTimeprices"
                        @showChooseTimePrice="switchToChooseTimePrice"
                        @goBack="switchToHomePermalinkDefault"
                    />
                  </div>
                </div>
                <div v-if="currentComponent === 'ChooseTimePrice'" class="pt-5 m-auto">
                  <div id="chooseTimePrice" class="tab-pane active in">
                    <ChooseTimePrice
                        :timeprices="selectedTimeprices"
                        @showChooseTimePriceOption="goNextFromChooseTimePrice"
                        @goBack="goBackFromChooseTimePrice"/>
                  </div>
                </div>
                <div v-if="currentComponent === 'ChooseTimePriceOption'" class="pt-5 m-auto">
                  <div id="chooseTimePriceOption" class="tab-pane active in">
                    <ChooseTimePriceOption
                        @goBack="switchToChooseTimePrice"
                        @goNext="switchToChooseTherapist"/>
                  </div>
                </div>
                <div v-if="currentComponent === 'CustomerInfo'" class="pt-5 m-auto">
                  <div id="customerInfo" class="tab-pane active in">
                    <CustomerInfo
                        :startDate="selectedStartDate"
                        :endDate="selectedEndDate"
                        :currentCustomer="currentCustomer"
                        :selectedTimeprice="selectedTimeprice"
                        :selectedTimepriceOptions="selectedTimepriceOptions"
                        @goBack="goBackFormCustomer"
                    />
                  </div>
                </div>
                <div v-if="currentComponent === 'FormCustomer'" class="pt-5 m-auto">
                  <div id="formCustomer" class="tab-pane active in">
                    <FormCustomer
                        :currentCustomer="currentCustomer"
                        @goBack="goBackFromCustomerInfo"
                        @goNext="switchToCustomerInfoForm"
                    />
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import HomePermalinkDefault from './HomePermalinkDefault.vue';
import ChooseCategory from './ChooseCategory.vue';
import ChooseTimePrice from './ChooseTimePrice.vue';
import ChooseTimePriceOption from './ChooseTimePriceOption.vue';
import Calendar from './Calendar.vue';
import ChooseTherapist from './ChooseTherapist.vue';
import CustomerInfo from './CustomerInfo.vue';
import FormCustomer from './FormCustomer.vue';

export default {
  name: "Permalink",
  components: {
    HomePermalinkDefault,
    ChooseCategory,
    ChooseTimePrice,
    ChooseTimePriceOption,
    Calendar,
    ChooseTherapist,
    CustomerInfo,
    FormCustomer
  },
  data() {
    return {
      currentComponent: 'HomePermalinkDefault',
      selectedTimeprices: [],
      selectTimepriceTherapists: [],
      therapists: [],
      timeprice: null,
      selectedStartDate: null,
      selectedEndDate: null,
    };
  },
  computed: {
    ...mapGetters('permalink', [
      'currentCustomer',
      'clinic',
      'clinicName',
      'categoryTimeprices',
      'otherTimeprices',
      'timeprices_clinic',
      'selectedTimeprice',
      'selectedTimepriceOptions',
      'timepriceOptions'
    ])
  },
  methods: {
    ...mapActions('permalink', [
      'setSelectedTimeprice',
      'setSelectedTimepriceOptions',
      'setSelectedTherapist'
    ]),
    switchToChooseCategory() {
      if (this.categoryTimeprices.length === 0) {
        this.switchToChooseTimePrice();
      } else {
        this.currentComponent = 'ChooseCategory';
      }
    },
    switchToCalendar() {
      this.currentComponent = 'Calendar';
    },
    switchToChooseTherapist() {
      const isAnyOptionValid = this.selectedTimepriceOptions.some(option => option.timeunit === 0 || option.timeunit === null);
      if ((!this.selectedTimeprice.timeunit && isAnyOptionValid) || (!this.selectedTimeprice.timeunit && this.selectedTimepriceOptions.length === 0)) {
        this.currentComponent = 'ChooseTimePriceOption'
      } else {
        this.selectTimepriceTherapists = this.timepriceTherapists;
        this.currentComponent = 'ChooseTherapist';
      }
    },
    goBackFormCustomer() {
      if (this.currentCustomer.id) {
        this.switchToChooseTherapist();
      } else {
        this.switchToFormCustomer();
      }
    },
    switchToChooseTimePrice(timeprices) {
      if (timeprices) {
        this.setSelectedTimepriceOptions([]);
        this.selectedTimeprices = timeprices;
      }
      this.currentComponent = 'ChooseTimePrice';
    },
    switchToHomePermalinkDefault() {
      this.currentComponent = 'HomePermalinkDefault';
    },
    switchToChooseTimePriceOption() {
      this.currentComponent = 'ChooseTimePriceOption';
    },
    goNextFromChooseTimePrice() {
      if (this.timepriceOptions.length === 0) {
        this.setSelectedTimepriceOptions([]);
        this.switchToChooseTherapist();
      } else {
        this.setSelectedTimepriceOptions([]);
        this.switchToChooseTimePriceOption();
      }
    },
    goBackFromChooseTherapist() {
      if (this.timepriceOptions.length === 0) {
        this.setSelectedTherapist(null);
        this.switchToChooseTimePrice();
      } else {
        this.setSelectedTherapist(null);
        this.switchToChooseTimePriceOption();
      }
    },
    switchToFormCustomer() {
      this.currentComponent = 'FormCustomer';
    },
    handleEventSelected({ startDate, endDate }) {
      this.selectedStartDate = startDate;
      this.selectedEndDate = endDate;
    },
    switchToCustomerInfo() {
      if (this.currentCustomer && this.currentCustomer.id) {
        this.currentComponent = 'CustomerInfo';
      } else {
        this.switchToFormCustomer();
      }
    },
    switchToCustomerInfoForm(customer) {
      this.currentComponent = 'CustomerInfo';
    },
    goBackFromChooseTimePrice() {
      if (this.categoryTimeprices.length === 0) {
        this.switchToHomePermalinkDefault();
      } else {
        this.switchToChooseCategory();
      }
    },
    goBackFromCustomerInfo() {
      this.switchToChooseTherapist();
    },
    beforeEnter(el) {
      window.scrollTo(0,0);
    }
  },
  mounted() {
    const permalink = this.$route.params.permalink;
    this.$store.dispatch('permalink/fetchPermalinkData', permalink);
  }
};
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
